<!-- @format -->
<template>
    <post-hv-news v-if="this.$route.name === 'hvnews'"
        :post="post"
        :is-top-post="isTopPost"
        :show-post-type="showPostType"
        :show-subtitle="false"
        :show-snippet="false"
        default-top-post-image-path="sections/section-default-gavel.jpg"
        @single-post-view="$emit('single-post-view', $event)"
    />
    <post v-else
        :post="post"
        :is-top-post="isTopPost"
        :show-post-type="showPostType"
        :show-subtitle="false"
        :show-snippet="false"
        default-top-post-image-path="sections/section-default-gavel.jpg"
    />
</template>

<script>
import Post from './Post.vue';
import PostHvNews from './PostHvNews.vue';

export default {
    components: {
        Post,
        PostHvNews
    },
    props: {
        post: {
            type: Object,
            required: true
        },
        isTopPost: {
            type: Boolean,
            required: true
        },
        showPostType: {
            type: Boolean,
            required: true
        }
    }
};
</script>
